import gsap from 'gsap'
import { reduceMotion } from '@js/animations/ReducedMotion'

export class Parallax {
  constructor () {
    this._elements = document.querySelectorAll('[animation-parallax]')

    if (!this._elements.length || reduceMotion) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      gsap.to(el, {
        y: 40,
        scale: 1.08,
        ease: 'none',
        scrollTrigger: {
          trigger: el.closest('.s-hero') || el,
          start: 'top top',
          end: 'bottom top',
          scrub: 1,
        },
      })
    })
  }
}
